import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Zap, Droplets } from 'lucide-react';
export function SystemSection() {
  const cards = [{
    icon: Layers,
    title: '2 Proteínas Base',
    desc: 'La columna vertebral',
    delay: 0.2
  }, {
    icon: Zap,
    title: '1 Carbo Base',
    desc: 'Energía y saciedad',
    delay: 0.4
  }, {
    icon: Droplets,
    title: '1 Salsa Salvavidas',
    desc: 'Sabor = Adherencia',
    delay: 0.6
  }];
  return <section className="py-24 px-6 bg-warm-50" data-id="element-138">
      <div className="max-w-4xl mx-auto text-center" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-140">
          <span className="text-teal-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-141">
            La verdad incómoda (pero liberadora)
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-warm-900 mb-6 font-display" data-id="element-142">
            No necesitas variedad infinita.
            <br data-id="element-143" />
            Necesitas comidas resueltas.
          </h2>
          <p className="text-xl text-warm-900/80 max-w-2xl mx-auto" data-id="element-144">
            Comida resuelta es esto: proteína lista + algo que llene + algo que
            sepa bien.
          </p>
        </motion.div>

        <div className="mb-16" data-id="element-145">
          <h3 className="text-2xl font-bold text-warm-900 mb-10 font-display" data-id="element-146">
            Por eso existe el Sistema 2-1-1:
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-147">
            {cards.map((card, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: card.delay
          }} className="bg-white p-8 rounded-2xl shadow-card border border-warm-200 hover:border-teal-600/30 transition-colors" data-id="element-148">
                <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-4 text-teal-600" data-id="element-149">
                  <card.icon size={24} data-id="element-150" />
                </div>
                <h4 className="text-xl font-bold text-warm-900 mb-2" data-id="element-151">
                  {card.title}
                </h4>
                <p className="text-warm-900/60" data-id="element-152">{card.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-lg text-warm-900/80 max-w-2xl mx-auto space-y-4" data-id="element-153">
          <p data-id="element-154">Eso es todo.</p>
          <p data-id="element-155">
            Y de esa simplicidad sale lo que te falta hoy:{' '}
            <span className="font-bold text-teal-600" data-id="element-156">opciones.</span>
          </p>
          <p data-id="element-157">
            No “recetas”. Opciones armables que no dependen de tu motivación.
          </p>
        </motion.div>
      </div>
    </section>;
}